import Actions from '../../odata/actions';

const actions = new Actions('categoryCode', 'categoryCodes');

export default actions;
